import { stateSwitch } from '../stateSwitch';
import { spenttimeDebug as debug } from '../debug';
import { restartTimers } from './userActivityEvents';
/**
 * visibilitychange event handler
 * Can set the state 'pageIsVisible' and 'userIsSleeping'
 */
var visibilitychangeHandler = function () {
    debug("[event] Visibilitychange. User ".concat(document.hidden ? 'does not see' : 'sees', " the page"));
    if (document.hidden) {
        stateSwitch.setState({ pageIsVisible: false });
    }
    else {
        stateSwitch.setState({ pageIsVisible: true, userIsSleeping: false });
        restartTimers();
    }
};
/**
 * blur event handler
 * Can set the state 'pageIsVisible'
 */
var blurHandler = function () {
    debug('[event] Blur');
    stateSwitch.setState({ pageIsVisible: false });
};
export var addPageVisibilityListeners = function () {
    window.addEventListener('visibilitychange', visibilitychangeHandler);
    window.addEventListener('blur', blurHandler);
    debug('[event] Page visibility event listeners have been added');
};
export var removePageVisibilityListeners = function () {
    window.removeEventListener('visibilitychange', visibilitychangeHandler);
    window.removeEventListener('blur', blurHandler);
    debug('[event] Page visibility event listeners have been removed');
};
